import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DaProgressiveImageComponent } from './da-progressive-image.component';
import { CommonDirectivesModule } from '../../directives/common-directives.module';

@NgModule({
    imports: [CommonModule, CommonDirectivesModule],
    declarations: [DaProgressiveImageComponent],
    providers: [],
    exports: [DaProgressiveImageComponent]
})
export class DaProgressiveImageModule {}
